module.exports = __webpack_public_path__ + "img/arrow-left-double.162205fb.svg";